function formatResults(questions) {
  let data = '';
  questions.forEach((el) => {
    data = data + `${el.title}\n`;
    el.selectedAnswers.forEach((el) => {
      data = data + `- ${el}\n`;
    });
  });
  return data;
}

export default formatResults;
